export default {
  title: 'Bestellen & Zahlen vom Handy',
  description: 'Der schnellste Weg zu bestellen',
  buttons: {
    view_menu: 'Menü Ansehen & Bestellen',
  },
};